/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { computed } from '@ember/object';

export default class ProgressBar extends Component {
  mode = 'bar'; // supports; 'bar', 'radial'

  // variables
  @tracked totalItems = 0;

  @tracked completedItems = 0;
  label = 'Progress';
  diameter = 40; // Diameter of progress indicator when in radial mode.

  @computed('totalItems', 'completedItems')
  get progress() {
    if (!this.totalItems || !this.completedItems) {
      return 0;
    } else {
      return this.completedItems / this.totalItems;
    }
  }

  get percent() {
    return Math.round(this.progress * 100);
  }
}
